import React from "react";
import {
  withSitecoreContext,
  RichText,
} from "@sitecore-jss/sitecore-jss-react";

import "./index.scss";
import { PrivacyBannerModel } from "./models/PrivacyBanner.model";
import { PrivacyBannerProps } from "./types/PrivacyBanner.types";

const PrivacyBanner = (props: PrivacyBannerProps) => {
  const model = new PrivacyBannerModel(props);
  return (
    <>
      {props?.fields && (
        <div className="text-module--center privacy-banner TextModule__container">
          <div className="privacy-title sitecore-jss-form--titleText">
            <img hidden className="print-logo" src="http://cnhi001.westeurope.cloudapp.azure.com/cnhicorporate/-/jssmedia/Basic/CNHi/Content/Navigation/Logo_CNH_Industrialsvg.svg?iar=0&rev=-1&hash=73AAB3F32EEFF95CA84733EC23FBA41F" />
            <RichText field={model?.title} />
          </div>
          <div className="privacy-description">
            <RichText field={model?.subtitle} />
          </div>
        </div>
      )}
    </>

  );
};

export default withSitecoreContext()(PrivacyBanner);
